import { WorkspaceRoleV1, WorkspaceRoleV2 } from 'modules/CreateWorkspaceModal/types';

const isV2 = (role: WorkspaceRoleV1 | WorkspaceRoleV2): role is WorkspaceRoleV2 => 'powerLevels' in role;

const normalizeRole = (role: WorkspaceRoleV1 | WorkspaceRoleV2): WorkspaceRoleV2 => {
  if (isV2(role)) return role;

  const { powerLevel, ...rest } = role;

  return {
    ...rest,
    powerLevels: {
      workspace: powerLevel,
      chat: powerLevel,
      meeting: powerLevel,
    },
  };
};

export default normalizeRole;
